import { render, staticRenderFns } from "./PresetMedia.html?vue&type=template&id=f21178ba&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./PresetMedia.scss?vue&type=style&index=0&id=f21178ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21178ba",
  null
  
)

export default component.exports